import { render } from "./FinancialSupport.vue?vue&type=template&id=2bf94cee"
import script from "./FinancialSupport.vue?vue&type=script&lang=js"
export * from "./FinancialSupport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__